import { render } from "./WCItemGroupCollapsibleMenu.vue?vue&type=template&id=e1e3bc46&scoped=true"
import script from "./WCItemGroupCollapsibleMenu.vue?vue&type=script&lang=js"
export * from "./WCItemGroupCollapsibleMenu.vue?vue&type=script&lang=js"

import "./WCItemGroupCollapsibleMenu.vue?vue&type=style&index=0&id=e1e3bc46&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1e3bc46"]])

export default __exports__